import api from '../../../services/segi/index'

const segiHeaders = {
  'Content-Type': 'multipart/form-data',
  Accept: 'multipart/form-data',
}

export async function fecharPontoIndividual(graphId, mesMmYyyy, sobreescreve = false, cargaHorariaHhmm = null) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'fecha_ponto_individual')
  formData.append('mes', mesMmYyyy)
  formData.append('sobreescreve', sobreescreve ? '1' : '0')
  if (cargaHorariaHhmm) {
    formData.append('carga_horaria_hhmm', cargaHorariaHhmm)
  }
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}
